<iframe class="main" src="https://corridordigital.squarespace.com/privacy-korean" frameborder="0" scrolling="yes"
    height="100%" width="100%"></iframe>